// События главной — тем же способом, что и раньше: gtag (GA4) и fbq (Pixel)
// напрямую, без падений, если счётчика нет. Перенесено из HomePage.tsx как
// есть, чтобы двери первого экрана (HomeDoors.tsx) слали события так же.
import { isAnalyticsMuted } from "@/lib/analytics/mute";

export function ev(name: string, params: Record<string, unknown> = {}) {
  try {
    // /admin и вошедший админ — без аналитики (src/lib/analytics, 25.10.2026).
    if (isAnalyticsMuted()) return;
    const w = window as unknown as { gtag?: (...a: unknown[]) => void; fbq?: (...a: unknown[]) => void };
    w.gtag?.("event", name, params);
    w.fbq?.("trackCustom", name, params);
  } catch {
    /* аналитика не роняет страницу */
  }
}
